<template lang="pug">
  DataTablePage(
    mainColumn="name"
    longColumn="remark"
    resource="meterReading/readingUser"
    title="抄表员管理"
    label="抄表员"
    labelName="loginName"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth="70"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :updateList="updateList"
    :createList="createList"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import fullColumns from '@/containers/meterReading/fullColumns'
import { operationUpdate } from '@/containers/DataTablePage/operation'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'

export default {
  name: 'Account',
  components: {
    DataTablePage
  },
  data () {
    return {
      toolbar: [{
        ...toolbarCreate
      }],
      operation: [{
        ...operationUpdate
      //   name: 'map',
      //   label: '抄表轨迹',
      //   icon: 'patrol',
      //   funcProps: {
      //     account: this
      //   },
      //   func: () => {

      //   }
      // }, {
      //   name: 'book',
      //   label: '区本详情',
      //   icon: 'book',
      //   funcProps: {
      //     account: this
      //   },
      //   func: () => {

      //   }
      }],
      tableInitList: ['id', 'jobNumber', 'loginName', 'name', 'orgId', 'linkTel', 'linkPhone', 'enabled', 'remark'],
      tableFullList: ['id', 'jobNumber', 'loginName', 'name', 'orgId', 'linkTel', 'linkPhone', 'enabled', 'remark'],
      filterInitList: ['loginName', 'name', 'enabled'],
      filterFullList: ['loginName', 'name', 'enabled', 'linkTel', 'linkPhone', 'remark'],
      updateList: ['name', 'orgId', 'enabled', 'remark'],
      createList: ['loginName', 'name', 'orgId', 'enabled', 'remark'],
      columns: {
        ...fullColumns,
        name: {
          label: '姓名',
          width: 140,
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入姓名'
            }]
          }
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// Account.vue?213ee307